var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-sliced-text u-relative u-force-inline u-force-3d u-fit-w"},[_c('div',{staticClass:"c-sliced-text__base"},[_c('Textra',{attrs:{"data":_vm.content,"timer":2,"filter":"simple","infinite":!0}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19300216","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-sliced-text-rotator/index.vue
// module id = null
// module chunks = 